import { FC } from "react";
import { Modal } from "react-bootstrap";
import { Users } from "lucide-react";
import styles from "./style.module.scss";

const AVATAR_COLORS = [
  "#7C3AED", "#059669", "#2563EB", "#EA580C",
  "#DC2626", "#D946EF", "#0891B2", "#CA8A04",
  "#4F46E5", "#0D9488",
];

const getAvatarColor = (name: string) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
};

interface TeamData {
  teamId?: number;
  teamName: string;
  description?: string;
  leadAuditors?: { userId: number; name: string; email: string; roleType: string }[];
  auditors?: { userId: number; name: string; email: string; roleType: string }[];
}

interface Props {
  show: boolean;
  onClose: () => void;
  team: TeamData | null;
}

const ViewTeamMembersModal: FC<Props> = ({ show, onClose, team }) => {
  if (!team) return null;

  const leadAuditors = team.leadAuditors || [];
  const auditors = team.auditors || [];

  return (
    <Modal show={show} onHide={onClose} centered className={styles.modal}>
      <Modal.Header closeButton>
        <Modal.Title className={styles.modalTitle}>
          <Users size={20} className={styles.titleIcon} />
          <div>
            <div className={styles.titleText}>Team Members</div>
            <div className={styles.titleSub}>{team.description || team.teamName}</div>
          </div>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {leadAuditors.length > 0 && (
          <div className={styles.section}>
            <div className={styles.sectionLabel}>Lead Auditor</div>
            <div className={styles.memberGrid}>
              {leadAuditors.map((member) => (
                <div key={member.userId} className={styles.memberChip}>
                  <div
                    className={styles.memberAvatar}
                    style={{ backgroundColor: getAvatarColor(member.name) }}
                  >
                    {member.name.charAt(0).toUpperCase()}
                  </div>
                  <span className={styles.memberName}>{member.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {auditors.length > 0 && (
          <div className={styles.section}>
            <div className={styles.sectionLabel}>Team Members</div>
            <div className={styles.memberGrid}>
              {auditors.map((member) => (
                <div key={member.userId} className={styles.memberChip}>
                  <div
                    className={styles.memberAvatar}
                    style={{ backgroundColor: getAvatarColor(member.name) }}
                  >
                    {member.name.charAt(0).toUpperCase()}
                  </div>
                  <span className={styles.memberName}>{member.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ViewTeamMembersModal;